import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

export const CloseIcon: FunctionComponent<IIconProps> = ({ ...props }) => (
  <Icon {...{ viewBox: '0 0 20 20', ...props }}>
    <Path
      d="M4.75603 3.57739C4.43059 3.25195 3.90295 3.25195 3.57752 3.57739C3.25208 3.90283 3.25208 4.43047 3.57752 4.7559L8.88072 10.0591L3.57739 15.3624C3.25195 15.6879 3.25195 16.2155 3.57739 16.541C3.90283 16.8664 4.43047 16.8664 4.7559 16.541L10.0592 11.2376L15.3626 16.541C15.6881 16.8665 16.2157 16.8665 16.5411 16.541C16.8666 16.2156 16.8666 15.6879 16.5411 15.3625L11.2377 10.0591L16.541 4.75584C16.8665 4.4304 16.8665 3.90277 16.541 3.57733C16.2156 3.25189 15.6879 3.25189 15.3625 3.57733L10.0592 8.8806L4.75603 3.57739Z"
      fill="currentColor"
    />
  </Icon>
)
